<script>
  import UseFocusTrap from '../../utils/UseFocusTrap.svelte';
  import UseEscapeKeydown from '../../utils/UseEscapeKeydown.svelte';
  import UseClickOff from '../../utils/UseClickOff.svelte';
  import { actions } from '../../utils/actions';
  import BaseLink from '../BaseLink/BaseLink.svelte';
  import { SPRITESHEET_URL } from '../../utils/constants.ts';

  let { title, menuItems, a11yHelpTemplate, dataTestId = 'header-dropdown' } = $props();

  let isOpen = $state(false);
  let container = $state();

  const closeMenu = () => {
    isOpen = false;
  };

  const toggleMenu = () => {
    isOpen = !isOpen;
  };
</script>

{#if isOpen}
  <UseEscapeKeydown {container} onEscapeHandler={closeMenu} />
  <UseFocusTrap {container} />
  <UseClickOff {container} onClickOffHandler={closeMenu} />
{/if}
<div bind:this={container} class="h-full relative inline-block" data-testid={dataTestId}>
  <button
    class="h-full leading-tight font-semibold px-4 whitespace-nowrap hover-hover:hover:underline active:underline relative z-40"
    class:text-white={!isOpen}
    class:bg-white={isOpen}
    class:text-blue-navy={isOpen}
    aria-haspopup="menu"
    aria-expanded={isOpen}
    aria-label={a11yHelpTemplate.replace(/{{ITEMS}}/, menuItems.length).replace(/{{TITLE}}/, title)}
    onclick={toggleMenu}
  >
    <div class="flex flex-row items-center">
      {title}
      <div class="w-5 h-5 shrink-0 inline-block ml-1">
        <svg
          class="w-full h-full fill-current rotate-90 transition-transform duration-150 ease-in-out"
          class:-rotate-90={isOpen}
        >
          <use xlink:href={`${SPRITESHEET_URL}chevron-right`} />
        </svg>
      </div>
    </div>
  </button>
  <div
    class="absolute top-16 py-2 px-4 flex flex-col text-left bg-white rounded-b-lg pseudo-shadow-hover shadow-y-sm
    active:shadow-active border-r border-l border-b border-gray-light-silver -ml-px"
    class:hidden={!isOpen}
    class:block={isOpen}
  >
    {#each menuItems as item, index (index)}
      {#if item.url}
        <BaseLink
          className="py-2 px-1 leading-tight font-semibold text-blue-navy whitespace-nowrap hover-hover:hover:underline active:underline"
          url={item.url}
        >
          {item.text}
        </BaseLink>
      {:else if item.event}
        <button
          onclick={() => {
            actions(item.event);
            closeMenu();
          }}
          class="py-2 px-1 last:mb-0 leading-tight font-semibold text-blue-navy whitespace-nowrap text-left
          hover-hover:hover:underline active:underline"
        >
          {item.text}
        </button>
      {/if}
    {/each}
  </div>
</div>
